import { render, staticRenderFns } from "./ModelNameMappingRuleMaintain.vue?vue&type=template&id=20b56e53"
import script from "./ModelNameMappingRuleMaintain.vue?vue&type=script&lang=js"
export * from "./ModelNameMappingRuleMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports